import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
gsap.registerPlugin(SplitText)

export const splitText = () => {

	const wordsToSplit = document.querySelectorAll('[data-split-words]'),
		charsToSplit = document.querySelectorAll('[data-split-chars]'),
		linesToSplit = document.querySelectorAll('[data-split-lines]')

	document.fonts.ready.then(() => {

		const wordSplit = new SplitText(wordsToSplit, { type: 'words', wordsClass: 'word' }),
			lineSplit = new SplitText(linesToSplit, { type: 'lines', linesClass: 'line' }),
			charSplit = new SplitText(charsToSplit, { type: 'chars', charsClass: 'char' })

		wordSplit.words.forEach(el => {
			const text = el.innerHTML
			const wrap = document.createElement('div')
			wrap.classList.add('word__wrap')
			wrap.innerHTML = text
			el.innerHTML = ''
			el.appendChild(wrap)
		})

	})
}

export default () => { }